export const SET_FILTER = "SET_FILTER";

export const setFilter = (filter: any) => ({ type: SET_FILTER, payload: { filter } });
